import { AccessorsMutatorsDecorator } from "../../helpers";
import { Model } from "../../helpers";
import { TranslatableModel } from './translatable-model';

/**
 * @class Invoicing
 * @property {number} id
 */
export class Invoicing extends TranslatableModel {

    static get GENERATION_TYPE_MANUAL() {

        return {
            key: 0,
            value: 'I_WILL_GENERATE_INVOICES_MYSELF'
        };
    }

    static get GENERATION_TYPE_AUTO() {

        return {
            key: 1,
            value: 'GENERATE_INVOICE_WHEN_NEW_RESERVATION_CREATED'
        };
    }

    static get GENERATION_TYPES() {

        return [
            this.GENERATION_TYPE_AUTO,
            this.GENERATION_TYPE_MANUAL
        ];
    }

}

AccessorsMutatorsDecorator('id', 'title', 'title_ar', 'prefix', 'start_index',
        'suffix', 'tax_id', 'generation_type','grouped_transactions', 'default_due_date', 'show_room_number',
        'custom', 'custom_ar')(Invoicing);



// WEBPACK FOOTER //
// ./src/pms-api/models/invoicing.model.js